import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';

export default class LastUpdatedDateResource extends FBaseService {
  public async get(): Promise<string> {
    const url = '/api/lastUpdatedDate';

    const response: AxiosResponse = await this.apiClient.get(url);
    return response.data.data;
  }
}
